<!--[DOCTYPEID] = <DOCTYPEID, int,>
      ,[DOCKIND] = <DOCKIND, int,>
      ,[DOCNAME] = <DOCNAME, varchar(64),>
      ,[DOCNOTE] = <DOCNOTE, varchar(255),>
      ,[DOCSGROUP1] = <DOCSGROUP1, varchar(50),>
      ,[DOCSECGROUPID] = <DOCSECGROUPID, int,>
      ,[DOCUSEFORFACTTABLE] = <DOCUSEFORFACTTABLE, int,>
      ,[DOCNAME1] = <DOCNAME1, varchar(255),>
      ,[DOCTEXTBEFORE] = <DOCTEXTBEFORE, text,>
      ,[DOCTEXTAFTER] = <DOCTEXTAFTER, text,>
      ,[DEFAULTVALTERM] = <DEFAULTVALTERM, int,>
      ,[DEFAULTEXPTERM] = <DEFAULTEXPTERM, int,>
      ,[OPTIONALPARMSTR] = <OPTIONALPARMSTR, nvarchar(1024),>-->

<p-accordion [multiple]="true" (onOpen)="onTabOpen($event)">
  <p-accordionTab [selected]="true" styleClass="">
    <ng-template pTemplate="header">
      <h5>Описание и параметры</h5>
    </ng-template>
    <div class="fluid formgrid grid" appStopAccordionHomeEnd>

      <div class="field col-6 xl:col-6 sm:col-12">
        <label for="PR5" class="do-not-wrap-text">Название документа</label>
        <input id="PR5" type="text" pInputText [(ngModel)]="docType.DOCNAME" />
      </div>

      <div class="field col-6 xl:col-6 sm:col-12">
        <label for="PR7" class="do-not-wrap-text">Альтернативное название документа</label>
        <input id="PR7" type="text" pInputText [(ngModel)]="docType.DOCNAME1" />
      </div>

      <div class="field col-12">
        <label for="PR9" class="do-not-wrap-text">Описание</label>
        <input id="PR9" type="text" pInputText [(ngModel)]="docType.DOCNOTE" />
      </div>

      <div class="field col-3 xl:col-3 sm:col-12">
        <label for="PRP" class="do-not-wrap-text">Категория</label>
        <p-dropdown id="PRP" [options]="listDOCKIND" [(ngModel)]="docType.DOCKIND" optionLabel="value" optionValue="index"></p-dropdown>
      </div>

      <div class="field col-2 xl:col-2 sm:col-12">
        <label for="DC4" class="do-not-wrap-text">Используется в отчетах</label>
        <input id="DC4" type="number" pInputText [(ngModel)]="docType.DOCUSEFORFACTTABLE" min="1" step="1" />
      </div>

      <div class="field col-3 xl:col-3 sm:col-12">
        <app-security-group-selector #sgs1 labelKey="Группа доступа" [selectedID]="docType.DOCSECGROUPID" (selectedSecurityGroup)="onSelectedSecurityGroup($event)"></app-security-group-selector>
      </div>

      <div class="field col-4 xl:col-4 sm:col-12">
        <label for="PR8" class="do-not-wrap-text">Описание группы</label>
        <input id="PR8" type="text" pInputText [(ngModel)]="docType.DOCSGROUP1" />
      </div>

      <div class="field col-2 xl:col-2 sm:col-6">
        <label for="DC4" class="do-not-wrap-text">Срок действия</label>
        <input id="DC4" type="number" pInputText [(ngModel)]="docType.DEFAULTVALTERM" min="1" step="1" />
      </div>

      <div class="field col-2 xl:col-2 sm:col-6">
        <label for="DN1" class="do-not-wrap-text">Срок исполнения</label>
        <input id="DN1" type="number" pInputText [(ngModel)]="docType.DEFAULTEXPTERM" min="1" step="1" />
      </div>
      <div class="field col-8 xl:col-8 sm:col-12">
        <label for="DN2" class="do-not-wrap-text">Дополнительные параметры</label>
        <input id="DN2" type="text" pInputText [(ngModel)]="docType.OPTIONALPARMSTR" />
      </div>

    </div>
  </p-accordionTab>

  <p-accordionTab [selected]="false" styleClass="">
    <ng-template pTemplate="header">
      <h5>Преамбула и условия</h5>
    </ng-template>
    <div class="fluid formgrid grid" appStopAccordionHomeEnd>
      <div #DDH class="field col-12">
        <p-editor [(ngModel)]="docHeaderStatement" [style]="{'height':'20vw'}">
        </p-editor>
      </div>
      <div #DDF class="field col-12">
        <p-editor [(ngModel)]="docFooterStatement" [style]="{'height':'20vw'}">
        </p-editor>
      </div>
    </div>
  </p-accordionTab>

</p-accordion>

<div class="grid formgrid justify-content-end">
  <p-button label="Сохранить" icon="pi pi-check" (onClick)="onConfirm(1)" styleClass="ml-2 mt-2 mr-2" [disabled]="noChangesThere"></p-button>
</div>
